import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { BrandedLoader } from '../ui/BrandedLoader';

/**
 * Garde des routes /portail/*. Exige une session ET un client_user actif.
 * Un collaborateur cabinet est redirigé vers le dashboard cabinet.
 */
export function ClientGuard() {
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const identityResolved = useAuthStore((s) => s.identityResolved);
  const session = useAuthStore((s) => s.session);
  const clientUser = useAuthStore((s) => s.clientUser);
  const collaborator = useAuthStore((s) => s.collaborator);

  if (!isInitialized) return <BrandedLoader />;

  if (!session) return <Navigate to="/login" replace />;

  // Identité pas encore résolue : on attend le fetch (pas de flash "Compte non reconnu").
  if (!identityResolved) return <BrandedLoader />;

  // Collaborateur cabinet sur une route portail → renvoyé chez lui.
  if (collaborator) return <Navigate to="/dashboard" replace />;

  if (!clientUser) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cime-bg">
        <div className="max-w-md w-full p-8 text-center bg-cime-surface rounded-cime border border-neutral-200 shadow-sm">
          <p className="text-lg font-semibold text-neutral-900 mb-2">
            Compte non reconnu
          </p>
          <p className="text-sm text-neutral-600">
            Votre compte n&apos;est associé à aucun dossier. Contactez votre cabinet.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
